// Import necessary functions from Pinia
import { defineStore } from 'pinia';

export const useMobileFiltersMenuStore = defineStore('mobileFiltersMenu', {
    state: () => ({
        open: false, // Default state of the menu
    }),

    // Actions for updating the state
    actions: {
        toggleMenu() {
            if (!this.open) {
                document.body.style.overflow = 'hidden';
            }
            this.open = !this.open; // Toggle between true and false
        },
        openMenu() {
            this.open = true; // Explicitly open the menu
        },
        closeMenu() {
            document.body.style.overflow = '';
            this.open = false; // Explicitly close the menu
        },
    },

    // Optional: Getters if you want computed-like properties
    getters: {
        isOpen: state => state.open, // Return whether the menu is open
    },
});
